import { hideOwnFlags } from './meta';
import type { Prefs } from './prefs';

/**
 * Labels op posters (4K, HDR, Atmos, score): standaard volgens de skin, of eigen keuze
 * van het profiel (Instellingen → Metadata en artwork). Labels van SpatialPosters gaan voor.
 */

type Flags = 'off' | 'basic' | 'full';
type Pos = 'tl' | 'tr' | 'bl' | 'br';

let skin: { flags: Flags; pos: Pos } = { flags: 'off', pos: 'tl' };
let pref: Pick<Prefs, 'posterLabels' | 'posterLabelsPos' | 'posterLabelSize' | 'posterScore' | 'posterScorePos' | 'posterLabelStack'> | null = null;

export function applyLabels(): void {
  const root = document.documentElement;
  const off = hideOwnFlags();
  root.dataset.mflags = off ? 'off' : pref && pref.posterLabels !== 'skin' ? pref.posterLabels : skin.flags;
  const flagsPos: Pos = pref && pref.posterLabelsPos !== 'skin' ? pref.posterLabelsPos : skin.pos;
  root.dataset.mflagsPos = flagsPos;
  root.dataset.mflagsSize = pref?.posterLabelSize ?? 'normal';
  root.dataset.mflagsStack = pref?.posterLabelStack ?? 'auto';
  const score = !off && !!pref?.posterScore;
  root.dataset.mscore = score ? 'on' : 'off';
  root.dataset.mscorePos = scorePos(flagsPos, pref?.posterScorePos ?? 'auto');
  // Staat er bovenin nog iets naast het statuslabel (rechtsboven)? Dan wordt dat label kort (✓, +, klokje)
  const topShared = (root.dataset.mflags !== 'off' && flagsPos[0] === 't') || (score && root.dataset.mscorePos === 'tl');
  root.dataset.mcompact = topShared ? 'on' : 'off';
}

/**
 * Nooit twee dingen in dezelfde hoek: rechtsboven is van het statuslabel, de labels hebben hun eigen hoek.
 * Automatisch (of bij een bezette hoek): de eerste vrije van linksonder, rechtsonder, linksboven.
 */
export function scorePos(flagsPos: Pos, want: 'auto' | Pos): Pos {
  const free = (['bl', 'br', 'tl'] as Pos[]).filter((p) => p !== flagsPos);
  if (want === 'auto' || want === 'tr' || want === flagsPos) return free[0];
  return want;
}

export function setSkinLabels(flags: Flags, pos: Pos): void {
  skin = { flags, pos };
  applyLabels();
}

export function setLabelPrefs(p: Prefs): void {
  pref = { posterLabels: p.posterLabels, posterLabelsPos: p.posterLabelsPos, posterLabelSize: p.posterLabelSize, posterScore: p.posterScore, posterScorePos: p.posterScorePos, posterLabelStack: p.posterLabelStack };
  applyLabels();
}
